export function resolveBranchId(hostname: string, search: string): string | null {
    const isLocal =
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        /^[0-9.]+$/.test(hostname) ||
        hostname.split(".").length < 3;

    if (isLocal) {
        const params = new URLSearchParams(search || "");
        const id = params.get("branchId") || params.get("branch");
        const sanitized = sanitizeBranchId(id);
        return sanitized || null;
    }

    const sub = hostname.split(".")[0];
    if (!sub || sub.toLowerCase() === "www") return null;

    const sanitized = sanitizeBranchId(sub);
    return sanitized || null;
}

function sanitizeBranchId(id: string | null): string | null {
    if (!id) return null;
    const sanitized = id.toLowerCase().replace(/[^a-z0-9-]/g, "").trim();
    return sanitized.length > 0 ? sanitized : null;
}

export function resolveCustomUrl(hostname: string, search: string): string | null {
    const isLocal =
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        /^[0-9.]+$/.test(hostname);

    if (isLocal) {
        const params = new URLSearchParams(search || "");
        const cu = params.get("custom_url") || params.get("customUrl");
        const trimmed = (cu || "").trim();
        return trimmed || null;
    }

    if (hostname.endsWith(".famasi.online")) {
        return hostname;
    }

    return null;
}

export function getCustomUrlFromLocation(): string | null {
    if (typeof window === "undefined") return null;
    return resolveCustomUrl(window.location.hostname, window.location.search);
}

export function getBranchIdFromLocation(): string | null {
    if (typeof window === "undefined") return null;
    return resolveBranchId(window.location.hostname, window.location.search);
}

export const extractBranchId = resolveBranchId;